 export default [
    {
        path: '/forum-api/:category?',
        name: 'forumList',
        component: () => import(/* webpackChunkName: "forum" */ '../views/List.vue'),
        props: true,
    },
    {
        path: '/forum-api/:category/topic/create',
        name: 'forumTopicCreate',
        component: () => import(/* webpackChunkName: "forum" */ '../views/TopicForm.vue')
    },

    {
        path: '/forum-api/:category/topic/:topic/edit',
        name: 'forumTopicEdit',
        component: () => import(/* webpackChunkName: "forum" */ '../views/TopicForm.vue')
    },
    {
        path: '/forum-api/:category/topic/:topic',
        name: 'forumTopicView',
        component: () => import(/* webpackChunkName: "forum" */ '../views/TopicView.vue')
    },
]